import { adjustTimezone, formatDate, normalizeHourForApi } from './UpdateCustomAccountsDownloadConfig';
import { PREVIEW_ROW_BAKED, PREVIEW_ROW_FLASH_IMPORT } from './flow_preview_constants';
import { isoUtcDateAndHour } from './preview_flow_schema';

/**
 * One-time normalization at fetch/load: `date` → YYYY-MM-DD, `hour` → HH:MM:SS.
 * Pluggy/JSON simple/Excel use `timezoneOffset`; Flash uses UTC from `row.date` only.
 * Idempotent if `PREVIEW_ROW_BAKED` is already true.
 */
export function bakePreviewRow(row, timezoneOffset) {
  if (!row || typeof row !== 'object') return row;
  if (row[PREVIEW_ROW_BAKED] === true) return row;

  const out = { ...row };

  if (out[PREVIEW_ROW_FLASH_IMPORT] === true) {
    const { datePart, hourPart } = isoUtcDateAndHour(String(out.date || ''));
    out.date = datePart || '';
    out.hour = normalizeHourForApi(out.hour, hourPart && /^\d{2}:\d{2}/.test(hourPart) ? hourPart : '00:00:00');
    delete out[PREVIEW_ROW_FLASH_IMPORT];
    out[PREVIEW_ROW_BAKED] = true;
    return out;
  }

  const adjusted = adjustTimezone(out.date, timezoneOffset);
  if (Number.isNaN(adjusted.getTime())) {
    out[PREVIEW_ROW_BAKED] = true;
    delete out[PREVIEW_ROW_FLASH_IMPORT];
    return out;
  }
  const isoTime = adjusted.toISOString().split('T')[1]?.split('.')[0] || '00:00:00';
  out.date = formatDate(adjusted);
  out.hour = normalizeHourForApi(out.hour, isoTime);
  delete out[PREVIEW_ROW_FLASH_IMPORT];
  out[PREVIEW_ROW_BAKED] = true;
  return out;
}

export function bakePreviewTransactions(transactions, timezoneOffset) {
  if (!Array.isArray(transactions)) return [];
  return transactions.map((r) => bakePreviewRow(r, timezoneOffset));
}

export function bakePreviewOpenfinanceData(openfinanceData, timezoneOffset) {
  if (!openfinanceData || typeof openfinanceData !== 'object') return {};
  return Object.fromEntries(
    Object.entries(openfinanceData).map(([k, v]) => [
      k,
      {
        ...v,
        transactions: bakePreviewTransactions(v.transactions || [], timezoneOffset),
      },
    ])
  );
}
